import firebase from 'firebase';

// should go in a secret file
const config = {
	apiKey: "AIzaSyDjygoFTQH45W3I532iAudfZ4NWkli0-w8",
	authDomain: "remote-ted.firebaseapp.com",
	databaseURL: "https://remote-ted.firebaseio.com",
	projectId: "remote-ted",
	storageBucket: "",
	messagingSenderId: "841174549619"
};
firebase.initializeApp(config);

export default firebase;


// WEBPACK FOOTER //
// ./src/firebase.js